// extracted by mini-css-extract-plugin
export var bodyRow = "_ib-d";
export var cardColumns = "_ib-e";
export var ellipsesOverflow = "_ib-2";
export var flatBottomCorners = "_ib-3";
export var flatTopCorners = "_ib-4";
export var headerActionsDropdown = "_ib-f";
export var headerBottomRow = "_ib-c";
export var headerTopRow = "_ib-b";
export var orderDetailsWrapper = "_ib-0";
export var orderInfoContainer = "_ib-1";
export var productDetails = "_ib-9";
export var productImage = "_ib-5";
export var responsiveTable = "_ib-8";
export var shipmentContainer = "_ib-a";
export var tableBottomLeft = "_ib-6";
export var tableBottomRight = "_ib-7";
export var trackingLink = "_ib-g";